import { useState } from 'react';
import { faqData } from '@/mocks/home';

export default function FaqSection() {
  const [openId, setOpenId] = useState<number>(1);

  const toggleFaq = (id: number) => {
    setOpenId(openId === id ? 0 : id);
  };

  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          关于黑料官网与黑料网入口的常见疑问解答
        </p>

        <div className="max-w-2xl mx-auto flex flex-col gap-3">
          {faqData.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-50 border border-background-200/60 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(faq.id)}
                className="w-full flex items-center justify-between gap-4 p-4 md:p-5 text-left cursor-pointer"
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {faq.question}
                </h3>
                <span className={`shrink-0 transition-transform duration-200 text-foreground-400 ${
                  openId === faq.id ? 'rotate-180' : ''
                }`}>
                  <i className="ri-arrow-down-s-line text-lg"></i>
                </span>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openId === faq.id ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed px-4 md:px-5 pb-4 md:pb-5">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}